const Colors = {
    red: "#6b1d24",
    peach: "#eabb95",
    beige: "#ddc0a0",
    grey: "#777777",
    secondary_grey: "#f7f7f7",
    lightgrey: "aeaeae",
    white: "#f8f8f8",
    heroback: "rgba(209, 168, 134, 0.65)",
}

export default Colors
